import firebase from '../utils/firebase';

export function setupInactivityListener({ onSessionExpired, logout }) {

    let timer;
    const INACTIVITY_LIMIT = 2 * 60 * 60 * 1000; // 2 horas
    //const INACTIVITY_LIMIT = 1 * 30 * 1000; // 10 seg
  
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (firebase.auth().currentUser) {
          firebase.auth().signOut().then(() => {
            logout();            // función pasada desde App
            onSessionExpired();  // muestra el Snackbar
          });
        }
      }, INACTIVITY_LIMIT);
    };
  
    const events = ['click', 'mousemove', 'mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();
  
    return () => {
      clearTimeout(timer);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }